// src/components/HeaderWithAd/WebDesignBanner.jsx
import { motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";
import GraffitiHeroSummer from "../../assets/hero.webp";
import GraffitiHeroAutumn from "../../assets/hero2.webp";
import Logo from "../../assets/logo-buukkeri-dark.webp"; // <-- oma logosi

 export default function WebDesignBanner({
   children,
   bgImage,
   tall = false,
   hideLogo = false,
   hideLogoMobile = false,
 }) {
  const [theme, setTheme] = useState(() => {
    if (typeof document === "undefined") return "light";
    return document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
  });

  const prefersReducedMotion = useReducedMotion();

  useEffect(() => {
    if (
      typeof document === "undefined" ||
      typeof MutationObserver === "undefined"
    ) {
      return;
    }
    const obs = new MutationObserver(() => {
      setTheme(
        document.documentElement.classList.contains("dark")
          ? "dark"
          : "light"
      );
    });
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => obs.disconnect();
  }, []);

  // Jos bgImage annettu → käytä sitä, muuten kausikuva (summer/autumn)
  const heroImage =
    bgImage || (theme === "dark" ? GraffitiHeroAutumn : GraffitiHeroSummer);

  return (
<header
  className={
    "relative w-full min-h-[560px] overflow-visible " +
    (tall
      ? // Tall-variantti: anna kasvaa sisällön mukaan, mutta pidä vähimmäiskorkeus reiluna
        "h-auto min-h-[920px] xxxsm:min-h-[1450px] xxsm:min-h-[1200px] xsm:min-h-[1100px] sm:min-h-[1200px] md:min-h-[1300px]"
      : // Oletus: koko ruutu (nykyinen käytös)
        "h-screen")
  }
>

      {/* Taustakuva zoom-efektillä */}
      <motion.div
        className="absolute inset-0 z-0 will-change-transform"
        initial={{ scale: 1.02 }}
        animate={
          prefersReducedMotion
            ? { scale: 1.02 }
            : { scale: [1.02, 1.09, 1.02] }
        }
        transition={
          prefersReducedMotion
            ? { duration: 1 }
            : {
                duration: 12,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "mirror",
              }
        }
      >
        <img
          src={heroImage}
          alt="Buukkeri-hero"
          className="absolute inset-0 w-full h-full object-cover object-[50%_30%]"
        />
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-black/80 via-black/30 to-black/60" />
      </motion.div>

      {/* Sisältö */}
      <div
        className="
          absolute inset-0 z-10 pointer-events-none
          flex flex-col items-center
          justify-start pt-20
          lg:justify-center xl:justify-center 2xl:justify-center lg:pt-0
        "
      >
         {/* LOGO – voidaan piilottaa tietyillä sivuilla (esim. mobiilista) */}
        {!hideLogo && (
          <div className={hideLogoMobile ? "hidden sm:block" : "block"}>
            <img
              src={Logo}
              alt="Buukkeri logo"
              className="
                w-24 drop-shadow-lg pointer-events-auto
                pt-6 xsm:pt-24 sm:pt-24 md:pt-24 mdd:pt-24 lg:pt-24 xl:pt-24 2xl:pt-24

                hidden xxsm:block s24:block xsm:block sm:block md:block mdd:block lg:block xl:block 2xl:block
                md:w-60 mdd:w-60 lg:w-60 xl:w-72 2xl:w-72
              "
            />
          </div>
        )}

        {/* Lapset (otsikot, napit jne.) */}
        <div className="pointer-events-auto w-full mt-6 text-center">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </div>
      </div>
    </header>
  );
}
